export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  DRAFT_PREVIEWS: 'draftPreviews',
  COLOR_SCHEME: 'color_scheme',
  DISMISSED_LABEL_SUGGESTIONS: 'labelSuggestionsDismissed',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  RECENT_SEARCHES: 'recentSearches',
  CONVERSATION_PREFETCH_CACHE: 'conversationPrefetchCache',
  DOWNLOADED_DOCUMENTS: 'downloadedDocuments',
  // Aceleres: ultimo modulo acessado no Zoraxy (helper/aceleresLastModule.js).
  LAST_MODULE: 'aceleresLastModule',
};
